import { render, staticRenderFns } from "./WpStep2.vue?vue&type=template&id=79dc5880&"
import script from "./WpStep2.vue?vue&type=script&lang=js&"
export * from "./WpStep2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports